import { useTranslation } from "@flare/i18n";

import { DatePicker } from "@/components/Funnel/DatePicker";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { InputsContainer } from "../components/inputs-container";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

export default function UpcomingEventDate() {
  const { t } = useTranslation();

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle> {t("FUNNEL_UPCOMING_EVENT_DATE_TITLE")}</StepTitle>
          <StepSubtitle>
            {t("FUNNEL_UPCOMING_EVENT_DATE_SUBTITLE")}
          </StepSubtitle>
          <InputsContainer className="my-sp-5 max-w-[560px]">
            <DatePicker
              name={funnelInputsNameMap.upcomingEventDate}
              label={t("FUNNEL_UPCOMING_EVENT_DATE_LABEL")}
              placeholder={t("FUNNEL_UPCOMING_EVENT_DATE_PLACEHOLDER")}
              validationErrorMessage={t(
                "FUNNEL_UPCOMING_EVENT_DATE_VALIDATION_ERROR",
              )}
              required
            />
          </InputsContainer>
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
